export default "__VITE_ASSET__CtgqRsuW__"